import * as dayjs from 'dayjs'
import profileService from '@/services/http/profile/ProfileService'
import HttpUnAuthenticatedError from '@/objects/Exceptions/HttpUnAuthenticatedError'
import HttpError from '@/objects/Exceptions/HttpError'

export const reservations = () => {
  return {
    namespaced: true,
    state: {
      loading: false,
      reservations: [],
      reservationInModel: undefined,
      reservationState: undefined // none | upcoming | current
    },
    mutations: {
      SET_RESERVATIONS (state, reservations) {
        state.reservations = reservations
      },
      SET_RESERVATION_STATE (state, reservationState) {
        state.reservationState = reservationState
      },
      SET_LOADING (state, isLoading) {
        state.loading = isLoading
      },
      SET_RESERVATION_IN_MODEL (state, reservation) {
          state.reservationInModel = reservation
      }
    },
    actions: {
      setReservationInModal ({commit, state}, reservationId) {
        const reservation = state.reservations.find(r => r.id === reservationId)
        commit('SET_RESERVATION_IN_MODEL', reservation)
      },
      getReservations ({ commit, state }) {
        if (state.reservationState === undefined) {
          commit('SET_LOADING', true)
        }
        return profileService.getCurrentReservationGroup()
          .then(response => {
            console.log('response', response)
            commit('SET_RESERVATION_STATE', response.reservation_state ? response.reservation_state : undefined)
            commit('SET_RESERVATIONS', response.reservations ? parseReservations(response.reservations) : [])
            // commit('SET_RESERVATIONS', response.reservations ? [...parseReservations(response.reservations), ...parseReservations(response.reservations)] : []) // For testing purposes
            // commit('SET_CURRENT_RESERVATION', parseReservation(response))
          }).catch(() => {
              // TODO: Error handling
            console.log('Error')
            commit('SET_RESERVATION_STATE', 'none')
          }).finally(() => {
            commit('SET_LOADING', false)
          })
      }
    },
    getters: {
      isCheckedIn (state) {
        if (state.currentReservation) {
          return state.currentReservation.status === 'Started'
        }
        return false
      },
    }
  }
}

const parseReservations = (reservations) => {
  return reservations.map(r => {
    return {
      id: r.id || null,
      status: r.state || null, // ready-to-check-in |  checked-in | checked-out | canceled
      qrData: r.qrCode || null,
      number: r.number || null,
      cube: r.cube || null,
      // roomNumber: r.space ? r.space.Name : '-',
      // floorNumber: r.space ? r.space.floorNumber : null,
      totalGuests: r.totalGuests || null,
      startDate: new dayjs(r.start || null),
      endDate: new dayjs(r.end || null),
      // rawSpace: {...space}, Space: We kunnen de cube laten zien na checkin
    }
  })
}

const parseReservation = (response) => {
  let reservation = {}
  let space = {};
  if (response.reservation && Array.isArray(response.reservation)) {
    reservation = response.reservation[response.reservation.length-1]
  }
  if (reservation.space) {
    space = reservation.space
  }

  return {
    status: reservation.status || null,
    qrData: reservation.qrData || null,
    number: reservation.number || null,
    roomNumber: reservation.space ? reservation.space.Name : '-',
    floorNumber: reservation.space ? reservation.space.floorNumber : null,
    totalAdults: reservation.totalAdults || null,
    totalChildren: reservation.totalChildren || null,
    startDate: new dayjs(reservation.checkInDate || null),
    endDate: new dayjs(reservation.checkOutDate || null),
    rawReservation: {...reservation},
    rawCustomer: {...reservation.customer},
    rawSpace: {...space},
  }
}
